<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="dedi"><em>For Audrey and Alice</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?db229ed0